import { REFRESH_INTERVAL, SERVER_HEARTBEAT } from "constants/actionTypes";

const initialState = {
  refreshIntervalMs: NaN,
  serverTimeDriftMs: 0,
};

export default function systemReducer(state = initialState, action) {
  switch (action.type) {
    case REFRESH_INTERVAL.ACTION:
      return {
        ...state,
        refreshIntervalMs: action.refreshIntervalMs,
      };
    case SERVER_HEARTBEAT.FETCH_BULK.SUCCESS:
      const {
        payload: {
          server_timestamp: timeOnServer,
          global_announcement: globalAnnouncement,
        },
      } = action;
      const drift = Date.now() - timeOnServer;
      return {
        ...state,
        serverTimeDriftMs: drift,
        globalAnnouncement,
      };
    default:
      return state;
  }
}
